module.exports = __webpack_public_path__ + "static/customize-01076534e6b0d0acc90de7e29f7013c4.png";